(ns quuppa.qsm.release-notes.subs
  (:require [re-frame.core :as rf]))

(rf/reg-sub
  ::release-notes
  (fn [db [_]]
    (get db :release-notes)))

(rf/reg-sub
  ::version
  :<- [::release-notes]
  (fn [release-notes [_]]
    (:version release-notes)))

(rf/reg-sub
  ::content
  :<- [::release-notes]
  (fn [release-notes [_]]
    (:content release-notes)))

(rf/reg-sub
  ::show-modal
  :<- [::release-notes]
  (fn [release-notes [_]]
    (:show-modal release-notes)))


(rf/reg-sub
  ::hash
  :<- [::release-notes]
  (fn [release-notes [_]]
    (:hash release-notes)))

(rf/reg-sub
  ::loading?
  :<- [::release-notes]
  (fn [release-notes [_]]
    (:loading? release-notes false)))

(rf/reg-sub
  ::available?
  :<- [::release-notes]
  (fn [release-notes [_]]
    (:available? release-notes false)))

